/**
 * Media fit utility — translates admin-chosen display mode to Tailwind classes.
 *
 * Modes (per /backend/routes/site_media.py MediaItem.fit):
 *  - "cover"   → object-cover, fills the frame, edges may crop (default)
 *  - "contain" → object-contain, shows the entire image, may letterbox
 *  - "natural" → object-none (natural pixel size, centered on background)
 *
 * Each storefront slot renderer (AdminHero, CollectionTileMedia,
 * LifestyleGallery, AboutMediaSlot, etc.) calls this for the per-item class.
 */
export const fitToClass = (fit) => {
  if (fit === 'contain') return 'object-contain';
  if (fit === 'natural') return 'object-none';
  return 'object-cover';
};

/**
 * Tailwind background class for the empty space around 'contain' /
 * 'natural' media. We darken hero contexts and stay neutral on light pages.
 */
export const fitBgClass = (fit, dark = false) => {
  if (fit === 'cover') return '';
  return dark ? 'bg-[#0F0A06]' : 'bg-[#1E140B]';
};
